import React from 'react'
import { connect } from 'react-redux'
import { nullDate } from '../../public/utility'
import { doGetForgetSwipeCardApply, doSaveForgetSwipeCardApply, doDeleteForgetSwipeCardApply } from '../../reducers/actions'
import { hasChangedValues, getFormValue } from '../../public/utility/formValues'
import { doForgetSwipeCardApplyAction } from '../../business/ForgetSwipeCardApplyAction'
class ForgetSwipeCardApply extends React.Component {
    state = {
        changedValues基本信息: {},
        id: this.props.match.params.id,
    }

    componentDidMount = () => {
        const { id } = this.state
        this.doGetForgetSwipeCardApply(id, this.props.checkRecordID, '', true)
    }

    doGetForgetSwipeCardApply = (id, checkRecordID, date, bChanged) => {
        const { dispatch, taskName } = this.props
        const { changedValues基本信息 } = this.state
        dispatch(doGetForgetSwipeCardApply({
            id: id || 0,
            checkRecordID,
            date,
            taskName,
            onEnd: ({ errorMessage, initValues基本信息, }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    if (bChanged) {
                        this.setState({ id, initValues基本信息, changedValues基本信息: {}, })
                    }
                    else {
                        const newChange = {
                            ...changedValues基本信息,
                            上班刷卡时间: initValues基本信息.上班刷卡时间, 下班刷卡时间: initValues基本信息.下班刷卡时间,
                            实际上班时间: initValues基本信息.实际上班时间, 实际下班时间: initValues基本信息.实际下班时间
                        }
                        this.setState({ id, initValues基本信息, changedValues基本信息: newChange })
                    }
                }
            }
        }))
    }

    handlerSave = () => {
        const { dispatch, checkRecordID } = this.props
        const { id, changedValues基本信息, } = this.state
        dispatch(doSaveForgetSwipeCardApply({
            id,
            checkRecordID,
            changedValues基本信息,
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    this.setState({ id })
                    this.doGetForgetSwipeCardApply(id, 0, '', true)
                }
            }
        }))
    }

    handlerClose = () => {
        const { } = this.props
        if (!this.bChanged()) {
            window.history.back()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', () => window.history.back())
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return Object.keys(changedValues基本信息).length > 0 &&
            values.忘刷卡日期 && values.实际上班时间 && values.实际上班时间 !== nullDate && values.实际下班时间 && values.实际下班时间 !== nullDate &&
            values.原因说明 && (values['附件-added'] || (values.附件 && values.附件.length > 0))
    }

    bSubmit = () => {
        const { changedValues基本信息 } = this.state
        return Object.keys(changedValues基本信息).length > 0
    }

    handelSubmit = (action, title) => {
        const { dispatch, showDetail } = this.props
        const { id } = this.state
        doForgetSwipeCardApplyAction(dispatch, title, { id: id, action: action, onSave: this.handlerClose, showDetail: showDetail })
    }

    handleChange = (v) => {
        this.doGetForgetSwipeCardApply(this.props.id, this.props.checkRecordID, v, false)
    }

    handlerDelete = () => {
        const { dispatch, onSave } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            dispatch(doDeleteForgetSwipeCardApply({
                id,
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        window.history.back()
                    }
                }
            })))
    }

    fieldset基本信息 = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return [
            { _text: '申请编号', disabled: true, },
            { _date: '创建日期', disabled: true, },
            { _text: '员工编号', disabled: true, },
            { _text: '员工姓名', disabled: true, },
            { _text: '部门名称', disabled: true, },
            { _text: '职务名称', disabled: true, },
            { _select: '忘刷卡日期', options: values.items忘刷卡日期, onChange: (v) => this.handleChange(v), required: true, },
            { _datetime: '上班刷卡时间', disabled: true, },
            { _datetime: '下班刷卡时间', disabled: true, },
            { _datetime: '上班忘刷卡时间', name: '实际上班时间', required: true, },
            { _datetime: '下班忘刷卡时间', name: '实际下班时间', required: true, },
            { _text: '原因说明', required: true, },
            { _files: '附件', required: true, },
            { _text: '备注', maxRows: 3, },
        ]
    }

    fieldset流转日志 = () => {
        return [
            { _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
    }

    render() {
        const { showMessage: Message, showBody: Body, readOnly, notSubmit } = this.props
        const { errorMessage, id, initValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const { 状态, 提交时间 } = initValues基本信息
        return <Body data={this}
            controls={
                readOnly ? [
                    { _button: this.bChanged() && '取消' || '关闭', icon: '', handler: this.handlerClose }
                ] : [
                    { _flow: 'ForgetSwipeCardApplyFlow', disabled: this.bSave(), cdt: () => id > 0 && (!notSubmit || 状态 == 1), id: getFormValue(this, '基本信息', 'ArchivesID'), onFinish: () => window.history.back() },
                    { _button: '保存', icon: '', handler: this.handlerSave, disabled: !this.bSave(), cdt: () => 状态 == 1, },
                    { _button: '删除', icon: '', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => id > 0 && 状态 == 1 && 提交时间 == nullDate },
                    { _button: this.bChanged() && '取消' || '关闭', icon: '', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '忘刷卡申请单', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: 状态 !== 1 || readOnly, docked: 'top', height: '68%', },
                    { title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
                ]
            }
        />
    }
}

export default connect()(ForgetSwipeCardApply)